import { IRegistrantDTO } from '../../api/control.dao';
import {
    IRegistrant
} from '../../components/_events/_manage-event/_control/_attendees-live-form/participants-live-form/partisipants-live-form-registrants-tab.viewmodel';

export function mapRegistrantDtoToRegistrant(registrant: IRegistrantDTO): IRegistrant {
    const name = registrant.name;
    const firstLastName = name.split(' ');
    return {
        ...registrant,
        firstName: firstLastName[0],
        lastName: firstLastName[1] || '',
    };
}